import {
  RefundReason,
  TransactionType,
} from '@Encore-FastStartup-Phase-Out/encore-shared';

export const transactionTypeToString = (type: TransactionType) => {
  switch (type) {
    case TransactionType.OrderPayment:
      return 'Order Payment';
    case TransactionType.AdminRefund:
      return 'Admin refund';
    case TransactionType.BundledShippingRefund:
      return 'Bundled Shipping Refund';
    case TransactionType.OrderPayout:
      return 'Order Payout';
    default:
      return type;
  }
};

export const refundReasonToString = (reason: RefundReason) => {
  switch (reason) {
    case RefundReason.CourtesyRefund:
      return 'Courtesy Refund';
    case RefundReason.DamagedBySeller:
      return 'Damaged By Seller';
    case RefundReason.DamagedInShipping:
      return 'Damaged In Shipping';
    case RefundReason.FakeItemSent:
      return 'Fake Item Sent';
    case RefundReason.IncorrectItemSent:
      return 'Incorrect Item Sent';
    case RefundReason.Other:
      return 'Other';
    default:
      return reason;
  }
};

export const sanitizeAmount = (value: string) => {
  const match = value.match(/^\d+(\.\d{0,2})?/);
  return match ? match[0] : value;
};

export const isFiniteNum = (n: any) =>
  typeof n === 'number' && Number.isFinite(n);
export const nonEmpty = (s?: string | null) =>
  !!(typeof s === 'string' ? s.trim() : s);
